var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accept"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    className: "cls-1",
    d: "M24.7,54.7H21a.75.75,0,0,0,0,1.5H24.7a.75.75,0,1,0,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    className: "cls-1",
    d: "M27.69,54.7H27a.75.75,0,0,0,0,1.5h.74a.75.75,0,0,0,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    className: "cls-1",
    d: "M22.46,25.57H46.37a.75.75,0,0,0,.75-.74h0v-3a.76.76,0,0,0-.75-.75H22.46a.75.75,0,0,0-.74.75h0v3a.74.74,0,0,0,.74.74Zm.75-3H45.62v1.49H23.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    className: "cls-1",
    d: "M22.46,31.55H46.37a.76.76,0,0,0,.75-.75h0v-3a.75.75,0,0,0-.75-.74H22.46a.74.74,0,0,0-.74.74h0v3a.75.75,0,0,0,.74.75Zm.75-3H45.62v1.5H23.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    className: "cls-1",
    d: "M22.46,37.52H46.37a.75.75,0,0,0,.75-.75h0v-3a.75.75,0,0,0-.75-.75H22.46a.74.74,0,0,0-.74.75h0v3a.74.74,0,0,0,.74.75Zm.75-3H45.62V36H23.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    className: "cls-1",
    d: "M36.65,39H22.46a.75.75,0,0,0,0,1.49H36.65a.75.75,0,1,0,0-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    className: "cls-1",
    d: "M32.17,41.26H22.46a.75.75,0,0,0,0,1.49h9.71a.75.75,0,1,0,0-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    className: "cls-1",
    d: "M24,45a.75.75,0,0,0,0-1.49h-1.5a.75.75,0,1,0,0,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    className: "cls-1",
    d: "M27,45a.75.75,0,0,0,0-1.49H26.2a.75.75,0,1,0,0,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    className: "cls-1",
    d: "M59.06,47.23a9,9,0,0,0-8.21-8.93V18.85a.79.79,0,0,0-.22-.53l-6-6a.75.75,0,0,0-.53-.22H18.73a.75.75,0,0,0-.75.74V57.69a.76.76,0,0,0,.75.75H50.1a.76.76,0,0,0,.75-.75V56.16A9,9,0,0,0,59.06,47.23ZM44.87,14.68,48.3,18.1H44.87ZM19.48,56.94V13.62h23.9v5.22a.75.75,0,0,0,.75.75h5.22v18.7a9,9,0,0,0,0,17.87v.77ZM50.1,54.7a7.47,7.47,0,1,1,7.47-7.47h0A7.46,7.46,0,0,1,50.1,54.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    className: "cls-1",
    d: "M55.86,44.46a.75.75,0,0,0-1.06,0L50,49.28l-3.23-1.94a.75.75,0,1,0-.82,1.25l0,0,3.73,2.24a.76.76,0,0,0,.92-.11l5.22-5.22a.75.75,0,0,0,0-1.06Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.dccf58f810dcb9ec8a767d0b07e8cc0c.svg";
export { ForwardRef as ReactComponent };